import { IBlock } from 'common/builder/blocks/blockInterfaces'
import { predicateConverter } from 'common/builder/components/chart/FlowChart/lib/PredicateConverter'
import { EmailContentRulePayload } from 'common/builder/components/chart/FlowChart/lib/types'
import { EmailContent } from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

import { EmailContentContverterRules } from './emailContentConverterRules/rules'

export const getEmailContentFromBlocks = (
  blocks: IBlock[],
  payload: EmailContentRulePayload,
): EmailContent[] => {
  return predicateConverter.convertEntities({
    entities: blocks,
    rules: EmailContentContverterRules,
    payload,
  })
}
